import { render, staticRenderFns } from "./BlogRoleSelector.vue?vue&type=template&id=2063e6a3&"
import script from "./BlogRoleSelector.vue?vue&type=script&lang=js&"
export * from "./BlogRoleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports